import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

export const SHOPIFY_SESSION_REFERRER_ALL_SUCCESS = 'SHOPIFY_SESSION_REFERRER_ALL_SUCCESS';
export const SHOPIFY_SESSION_REFERRER_ALL_LOADING = 'SHOPIFY_SESSION_REFERRER_ALL_LOADING';

const { ShopifySessionByReferrerAll: { getShopifySessionByReferrerAll } } = apiUrls;


export const getShopifySessionByReffererAllDetails = () => async (dispatch) => {
  try {

    const data = await REQUEST(getShopifySessionByReferrerAll);
    dispatch({
      type: SHOPIFY_SESSION_REFERRER_ALL_SUCCESS,
      data,
    })
  } catch (e) {

    dispatch({
      type: SHOPIFY_SESSION_REFERRER_ALL_SUCCESS,
      data: {
        code: "",
        modal: null,
        notifications: null,
        paginationInfo: null
      }
    })
  }

}

export const handleAllLoader = isAllLoading => (dispatch) => {
  dispatch({
    type: SHOPIFY_SESSION_REFERRER_ALL_LOADING,
    isAllLoading
  })
}
